<template>
  <mds-tbody class="custom-table__body">
    <component
      v-for="record in records"
      :key="record.id"
      :is="component"
      :record="record"
      :actions="actions"
      v-on="$listeners"
    />
  </mds-tbody>
</template>

<script>
import { MdsTbody } from '@mds/data-table'
import MwcBaseHelpersMixin from '@morningstar/mcl-utilities/src/vue/mixins/mwc-base-mixin'
import CustomTableRowFeed from './CustomTableRowFeed.vue'
import CustomTableRowSchedule from './CustomTableRowSchedule.vue'
import defaultConfig from '@/config/i18n'

const TABLE_TYPE_COMPONENT = {
  feeds: CustomTableRowFeed,
  schedules: CustomTableRowSchedule,
}

export default {
  name: 'CustomTableBody',
  components: {
    MdsTbody,
    CustomTableRowFeed,
  },
  props: {
    tableType: {
      type: String,
      default: 'feeds',
    },
    records: {
      type: Array,
      default: () => [],
    },
    actions: {
      type: Array,
      default: () => [],
    },
  },
  mixins: [MwcBaseHelpersMixin],
  data() {
    return {
      defaultConfig,
    }
  },
  computed: {
    component() {
      return TABLE_TYPE_COMPONENT[this.tableType]
    },
  },
}
</script>
